import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { actionCreators } from "./srereducer";
import { selectors } from "./srereducer";
import AudioLevel from "./AudioLevel";
import styled from "@emotion/styled";

var CalibrateMeterContainer = styled.div({
  textAlign: "center"
});

export var SRECalibrateMeter = function (_PureComponent) {
  _inherits(SRECalibrateMeter, _PureComponent);

  function SRECalibrateMeter() {
    var _temp, _this, _ret;

    _classCallCheck(this, SRECalibrateMeter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.render = function () {
      return React.createElement(
        CalibrateMeterContainer,
        { "data-qa": "CalibrateMeter" },
        React.createElement(AudioLevel, { value: _this.props.audioLevel })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return SRECalibrateMeter;
}(PureComponent);

SRECalibrateMeter.propTypes = {
  isSREListening: PropTypes.bool,
  isSREListeningToPrompt: PropTypes.bool,
  result: PropTypes.string
};

var mapStateToProps = function mapStateToProps(state, ownprops) {
  return {
    isSREListeningToPrompt: selectors.isSREListeningToPrompt(state, "CALIBRATE"),
    audioLevel: selectors.sreAudioLevelForPrompt(state, "CALIBRATE")
  };
};

var SRECalibrateContainer = connect(mapStateToProps, actionCreators)(SRECalibrateMeter);

export default SRECalibrateContainer;